import React, { useEffect, useState } from 'react'
const elemref = React.createRef()

export default function OnView (props) {
  const [showLoader, setShowLoader] = useState(true)
  const childrenLength = props.children.length
  useEffect(
    () => {
      if (childrenLength > 0) {
        setShowLoader(false)
      }
      const observer = new window.IntersectionObserver((entries, observer) => {
        const isIntersectionTrue = entries[0].isIntersecting
        props.hasMore && isIntersectionTrue && props.loadFunction()
      }, {
        'threshold': 0.9,
        // 'root': null,
        'rootMargin': '-40px'
      })
      setShowLoader(true)
      observer.observe(elemref.current)
      return () => observer.disconnect()
    },
    [childrenLength]
  )

  return (
    <>
      {props.children}
      {showLoader && <div ref={elemref}> {!!(props.hasMore) && props.loader} </div>}
    </>
  )
}
